import { useMemo } from 'react';
import { useQlubRouter } from '../hook/router';

export const countries = ['ae', 'jp', 'tr', 'br'];

export const supportedLanguages = ['en', 'ja', 'pt', 'ar', 'tr', 'zh', 'hk', 'es', 'ko', 'ru'];

const newLanguageSelector = ['hk'];

const countrySpecificLanguages: Record<string, string[]> = {
    hk: ['en', 'zh', 'hk'],
};

const getTitle = (value: string) => {
    switch (value) {
        case 'en':
            return 'English';
        case 'ar':
            return 'عربي';
        case 'de':
            return 'Deutsch';
        case 'ja':
            return '日本';
        case 'pt':
            return 'Português';
        case 'tr':
            return 'Türkçe';
        case 'zh':
            return '中文';
        case 'hk':
            return '繁體中文';
        case 'es':
            return 'Español';
        case 'ko':
            return '한국어';
        case 'ru':
            return 'Русский';
        default:
            return null;
    }
};

interface Language {
    value: string;
    title: any;
}

export const useLanguage = () => {
    const { url } = useQlubRouter();

    const languages: Language[] = useMemo(() => {
        return supportedLanguages.reduce<Language[]>((a, c) => {
            if (!countrySpecificLanguages.hasOwnProperty(url.cc) || countrySpecificLanguages?.[url.cc]?.includes(c)) {
                a.push({
                    value: c,
                    title: getTitle(c),
                });
            }
            return a;
        }, []);
    }, [url.cc]);

    const languageSelectorVariant = useMemo<'default' | 'no-flag'>(() => {
        return newLanguageSelector.includes(url.cc) ? 'no-flag' : 'default';
    }, [url.cc]);

    return {
        languages,
        languageSelectorVariant,
    };
};

export const LOCK_OVERLAY_Z_INDEX = 100000000;
